export default __webpack_public_path__ + "static/media/settingsgray.dfccc849.svg";